import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  getCountry,
  getLanguage,
  getText,
} from '../../internal/TextLabels/text'
import { moduleFetch } from '../../util/module-fetch'
import config from '../../../../config'
import { modules } from '../../../modules'
import { useModuleInfo } from '../../../modules/provider/ModuleInfoProvider'
import ModuleVersionNotification from '../../../modules/components/ModuleVersionNotification'

const Reconciliation = ({ doFetch }) => {
  const { moduleInfo, setModuleInfo } = useModuleInfo()
  const [showVersionNotification, setShowVersionNotification] = useState(false)

  const infoCallback = info => {
    const json = JSON.parse(info)
    if (moduleInfo && json._timestamp) {
      if (moduleInfo !== json._timestamp) {
        setShowVersionNotification(true)
      }
    } else {
      setModuleInfo(json._timestamp || '')
    }
  }

  useEffect(() => {
    modules.reconciliationApp.app().then(module => {
      module.inject(
        getCountry(),
        getLanguage(),
        'reconciliationRoot',
        doFetch,
        infoCallback,
        modules.reconciliationApp.basePath,
      )
    })
  }, [])

  return (
    <>
      <div id="reconciliationRoot">{getText('general.loading')}</div>
      {showVersionNotification && (
        <ModuleVersionNotification
          moduleName={getText(`modules.${modules.reconciliationApp.name}`)}
          hide={() => setShowVersionNotification(false)}
        />
      )}
    </>
  )
}

const mapDispatchToProps = dispatch => ({
  doFetch: (url, options) => {
    return dispatch(
      moduleFetch(config.federatedModules.reconciliation, url, options),
    )
  },
})

export default connect(null, mapDispatchToProps)(Reconciliation)
